module.exports = __webpack_public_path__ + "img/discount.b51270e5.png";